<div class="content-login">
  <div class="content">
    <mat-card class="example-card mat-elevation-z4">
      <div class="divImg">
        <img src="assets/img/logo.png" class="img" />
      </div>
      <form
        class="example-form"
        [formGroup]="loginForm"
        (submit)="login(loginForm.value)"
      >
        <div class="titleLogIn"><span>Ingresar - Panel</span></div>
        <div class="divInput">
          <mat-form-field
            class="example-full-width"
            appearance="fill"
            class="input"
          >
            <mat-label>Usuario</mat-label>
            <input
              type="email"
              formControlName="nombreUsuario"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>
        <div class="divInput">
          <mat-form-field
            class="example-full-width"
            appearance="fill"
            class="input"
          >
            <mat-label>Password</mat-label>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              matInput
              placeholder=""
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hidePassword"
              type="button"
            >
              <mat-icon>{{
                hidePassword ? "visibility_off" : "visibility"
              }}</mat-icon>
            </button>
          </mat-form-field>
          <div class="recuperar">
            <a
              class="recuperarEnlace"
              [routerLink]="['/auth/recuperar-contraseña-panel']"
              >Recuperar Contraseña</a
            >
          </div>
        </div>
        <!-- recuperar-contraseña -->
        <div class="divButton">
          <button
            type="submit"
            mat-raised-button
            color="primary"
            class="ingresar"
          >
            Ingresar
          </button>
        </div>
      </form>
    </mat-card>
  </div>
  <div class="version">
    <span class="versionTexto">VERSION</span>
    <span class="versionNumero">{{ VERSION }}</span>
  </div>
</div>
